import script from "./PragueGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./PragueGuide.vue?vue&type=script&lang=ts&setup=true"

import "./PragueGuide.vue?vue&type=style&index=0&id=ba011b22&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba011b22"]])

export default __exports__